import { RequestTypeStepDto } from "../Schemas/RequestTypeStepDto";
import { Section } from "./Section";
import { RequestParameterSectionDto } from "../Schemas/RequestParameterSectionDto";
import { utilities } from "../Utilities/file";
import { RequestFormContext } from "../RequestFormContext";
import { Box } from "@mui/material";

export type StepProps = RequestFormContext & {
    step: RequestTypeStepDto;
}

export const Step = ({ step, ...context }: StepProps) => {
    const getSections = (): JSX.Element[] => {
        return step.sections.map((section: RequestParameterSectionDto, index: number) => {
            return <Section
                key={index}
                section={section}
                {...context}
                pathToProp={`${context.pathToProp}.${utilities.createPathToProp("sections", index)}`}
            />
        })
    }

    return <Box className="step" sx={{ display: "flex", flexDirection: "column", gap: 1.5, }}>
        {getSections()}
    </Box>;
}